import { useEffect, useState } from "react";
import apiCall from "../../helpers/apifactory";
import Moment from "moment";
import { useNavigate, createSearchParams } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import { useFormik } from "formik";
import ErrorText from "./ErrorText";
import DatePicker from "react-date-picker";
import Select from "react-select";

// const YOUR_PRIVATE_KEY = "6Le3utQhAAAAAKR-L_9-laElwYvGEqxDWSBOMRps";

const RateTariff = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );

  // const cities = JSON.parse(cities2)
  const [ city,setCities] = useState([]);
  const [setDestState] = useState("");
  const [originState, setOriginState] = useState("");
  const [newcities, setNewCities] = useState([]);
  // const [isFCValid, setFromCityIsValid] = useState(true);
  // const [isTCValid, setToCityIsValid] = useState(true);
  const navigate = useNavigate();
  const [isValid, setIsValid] = useState(false);

  const handleChange = (e) => {
    setOriginState(e.value);
  };
  const handleChangeDestinate = (e) => {
    setDestState(e.value);
  };
  useEffect(() => {
    setIsValid(originState ? true : false);
  }, [originState]);

  useEffect(() => {
    apiCall
      .getCity()
        .then((res) => {
          console.log("00000")
          var cityarr = res?.data?.responseData?.cities?.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
          setCities(res?.data?.responseData?.cities);
        setNewCities(cityarr);

         console.log('77777777777777777', res?.data)
      })
      .catch((error) => {
        console.log("===============", error);
      });
  }, []);

  // useEffect(() => {
  //   // calloriginApi();
  //   // calldestinationApi();
  // }, [])

  // const calloriginApi = async () => {
  //   apiCall.originApi().then((d) => {
  //     const { IsSuccess, Data } = d.data;
  //     if (IsSuccess) {
  //       setOrigin(Data);
  //     } else {

  //     }
  //   }).catch((error) => {
  //     console.log(error);
  //   });
  // }

  // const calldestinationApi = async () => {
  //   apiCall.destinationApi().then((d) => {
  //     const { IsSuccess, Data } = d.data;
  //     if (IsSuccess) {
  //       setDestination(Data);
  //     } else {

  //     }
  //   }).catch((error) => {
  //     console.log(error);
  //   });
  // }

  // validationSchema = yup.object({
  //   originState: yup.object().required('This is Required'),
  // })

  const formik = useFormik({
    initialValues: {
      originState: undefined,
      destination: undefined,
      weight: "",
      date: "",
      recaptcha: "",
    },
    validationSchema: Yup.object({
      originState: Yup.object()?.required("This is Required"),
      destination: Yup.object()?.required("This is Required"),

      weight: Yup.string().required("This is Required"),
      date: Yup.string().required("This is Required"),
      recaptcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      // if (originState === "") {
      //   setFromCityIsValid(originState ? true : false);
      //   return;
      // }
      // if (destState === "") {
      //   setToCityIsValid(destState ? true : false);
      //   return;
      // }
      // alert(originState)
      // alert(destState)
      const param = {
        transdate: Moment(values?.date).format("DDMMYYYY"),
        weight: values?.weight,
        origin: values?.originState?.value,
        // origin: originState,
        // dstn: values?.destination?.split("-")[0],
        dstn: values?.destination?.value?.split("-")[0],
        // dstn: destState,
      };
      // alert(originState);

      navigate({
        pathname: "/Rates",
        search: createSearchParams(param).toString(),
      });
    },
  });

  return (
    <div>
      <div className="flex flex-col justify-center items-center mt-[1rem] flex-wrap mb-[5rem]">
        <div className="flex flex-col gap-1 p-4 shadow-my-lg text-sm md:w-[45rem] sm:w-[40rem] w-[auto]  mx-[auto] rounded-md transition-all duration-500">
          <h2 className="font-bold text-[1.1rem]">Get a quote form</h2>
          <div className="sm:flex grid gap-4 mt-2">
            <div className="flex-1 flex flex-col">
              <div className="relative">
                {/* <select
                  required
                  id="floating_outline"
                  value={formik?.values?.origin}
                  onChange={formik?.handleChange}
                  name="origin"
                  onBlur={formik?.handleBlur}
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                >
                  <option>Please Select</option>
                  {
                    cities?.map((data, index) => (
                      <option key={index} value={data?.['station_code']}>
                        {data?.['station_name']}
                      </option>
                    ))
                  }
                </select>
                <label
                  htmlFor="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Origin
                </label> */}

                {/* <Select
                  className="select1"
                  placeholder="Origin (city)"
                  name="originState"
                  value={newcities.find((obj) => obj.value === originState)}
                  options={newcities}
                  onChange={handleChange}
                />
                <ErrorText text={!isFCValid && <p>This is Required</p>} /> */}

                {/* <select
                  id="originState"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder="Origin (city)"
                  name="originState"
                  value={formik?.values?.originState}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {!formik?.values?.originState && (
                    <option>Please Select</option>
                  )}
                  {newcities?.map((data, index) => {
                    return (
                      <option key={index} value={data?.value}>
                        {data?.label}
                      </option>
                    );
                  })}
                </select> */}
                <Select
                  className="select1"
                  placeholder="Origin (city)"
                  name="originState"
                  id="originState"
                  value={formik?.values?.originState}
                  options={newcities}
                  onChange={(e) => {
                    formik?.setFieldValue("originState", e);
                  }}
                  onBlur={(e) => {
                    formik?.setFieldTouched("originState", true);
                  }}
                />
                <ErrorText
                  text={
                    formik?.touched?.originState && formik?.errors?.originState
                  }
                />
              </div>
              {/* <ErrorText text={formik?.touched?.originState && formik?.errors?.originState} /> */}
              {/* {!isValid && <p className='text-[red] text-[11px] font-semibold'>This is Required</p>} */}
            </div>
            <div className="flex-1 flex flex-col">
              <div className="relative">
                {/* <select
                  id="floating_outline"
                  value={formik?.values?.destination}
                  onChange={formik?.handleChange}
                  name="destination"
                  onBlur={formik?.handleBlur}
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder=" "
                >
                  <option>Please Select</option>
                  {
                    cities?.map((data, index) => (
                      <option key={index} value={data?.['station_code']}>
                        {data?.['station_name']}
                      </option>
                    ))
                  }
                </select> */}
                {/* <label
                  htmlFor="floating_outlined"
                  className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >
                  Destination
                </label> */}

                {/* <Select
                  className="select1 text-xs"
                  placeholder="Destination (city)"
                  name="to_City"
                  value={newcities.find((obj) => obj.value === destState)}
                  options={newcities}
                  onChange={handleChangeDestinate}
                />

                <ErrorText text={!isTCValid && <p>This is Required</p>} /> */}
                {/* <select
                  id="destination"
                  className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                  placeholder="Origin (city)"
                  name="destination"
                  value={formik?.values?.destination}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {!formik?.values?.destination && (
                    <option>Please Select</option>
                  )}
                  {newcities?.map((data, index) => {
                    return (
                      <option key={index} value={data?.value}>
                        {data?.label}
                      </option>
                    );
                  })}
                </select> */}
                <Select
                  className="select1"
                  placeholder="Destination (city)"
                  name="destination"
                  id="destination"
                  value={formik?.values?.destination}
                  options={newcities}
                  onChange={(e) => {
                    formik?.setFieldValue("destination", e);
                  }}
                  onBlur={(e) => {
                    formik?.setFieldTouched("destination", true);
                  }}
                />
                <ErrorText
                  text={
                    formik?.touched?.destination && formik?.errors?.destination
                  }
                />
              </div>

              {/* <ErrorText text={formik?.touched?.destination && formik?.errors?.destination} /> */}
            </div>
          </div>
          <div className="sm:flex grid gap-4 my-4 flex-wrap">
            <div className="flex-1 flex flex-col">
              <div className="MuiFormControl-root MuiTextField-root">
                <div className="relative">
                  <input
                    required
                    type="Number"
                    value={formik?.values?.weight}
                    onChange={formik?.handleChange}
                    name="weight"
                    min={0}
                    onBlur={formik?.handleBlur}
                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    placeholder=" "
                  />
                  <label
                    htmlFor="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/3 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Weight (kg)*
                  </label>

                  <ErrorText
                    text={formik?.touched?.weight && formik?.errors?.weight}
                  />
                </div>
              </div>
            </div>
            <div className="flex-1 flex flex-col ">
              <div className="MuiFormControl-root MuiTextField-root">
                <div className="relative">
                  <DatePicker
                    // className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                    className="calendar block px-2.5 h-[2.4rem] w-full text-sm text-light bg-transparent rounded border border-gray-500 focus:border-red hover:border-black"
                    name="date"
                    onChange={(e) => formik?.setFieldValue("date", e)}
                    onBlur={formik.handleBlur}
                    value={formik.values.date}
                    minDate={new Date()}
                  />
                  <label
                    htmlFor="floating_outlined"
                    className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                  >
                    Date
                  </label>
                </div>
                <ErrorText
                  text={formik?.touched?.date && formik?.errors?.date}
                />
              </div>
            </div>
          </div>
          <div className="flex">
            <div className="g-recaptcha">
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_CAPTCH}
                onChange={(value) => {
                  formik.setFieldValue("recaptcha", value);
                }}
              />
            </div>
          </div>
          <button
            type="submit"
            onClick={() => {
              formik?.handleSubmit();
            }}
            className=" text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[auto] mt-[1rem] rounded-md mb-6 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateTariff;
